import { LegacyAdChannels, ChannelConfig } from '../types/ad-channels';
import { Resolutions } from '../types/banner';

export const DEFAULT_CHANNEL_CONFIGS: Record<string, ChannelConfig> = {
  social: {
    value: 'social',
    label: 'Social Media'
  },
  display: {
    value: 'display',
    label: 'Medios digitales'
  },
  DOOH: {
    value: 'DOOH',
    label: 'DOOH'
  }
};

export const RESOLUTION_CATEGORIES: Record<Resolutions, LegacyAdChannels[]> = {
  '1080x1920': ['social'],
  '1080x1350': ['social'],
  '1080x1080': ['social'],
  '1920x1080': ['social', 'display'],
  '300x250': ['display'],
  '300x600': ['display'],
  '310x482': ['display', 'DOOH'],
  '400x600': ['display', 'DOOH']
};

export const RESOLUTION_DISPLAY_NAMES: Record<Resolutions, string> = {
  '300x250': '300x250',
  '300x600': '300x600',
  '310x482': '310x482',
  '400x600': '400x600',
  '1080x1920': '9:16',
  '1080x1080': '1:1',
  '1080x1350': '4:5',
  '1920x1080': '16:9'
};

export const RESOLUTIONS_ORDER: Resolutions[] = [
  '1920x1080',
  '1080x1920',
  '1080x1350',
  '1080x1080',
  '300x250',
  '300x600',
  '310x482',
  '400x600'
];
